module.exports = __webpack_public_path__ + "static/media/group_copy_3.f03b4e88.png";